<template>
  <v-app>
    <!-- Loading indicator while auth initializes -->
    <div v-if="authStore.loading && !maintenanceStore.active" class="auth-loading">
      <v-progress-circular indeterminate color="primary" size="48" />
    </div>

    <router-view />

    <!-- Global Dialogs -->
    <DialogContainer />

    <!-- Global Snackbars -->
    <SnackbarContainer />

    <!-- User Profile Completion Dialog -->
    <UserProfileCompletionDialog v-model="authStore.showProfileCompletionDialog" />

    <!-- Global Notifications -->
    <div class="notification-container">
      <v-snackbar
        v-for="notification in notificationStore.notifications"
        :key="notification.id"
        v-model="notification.show"
        :color="notification.type"
        :timeout="notification.persistent ? -1 : notification.timeout"
        :location="notifications.length > 1 ? 'top center' : 'bottom center'"
        :style="notifications.length > 1 ? { position: 'relative', marginBottom: '8px' } : {}"
      >
        {{ notification.message }}
        <template #actions>
          <v-btn
            variant="text"
            @click="notificationStore.hideNotification(notification.id)"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </v-app>
</template>

<script setup>
import { watch } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from './stores/authStore'
import { useNotificationStore } from './stores/notificationStore'
import { useMaintenanceStore } from './stores/maintenanceStore'
import DialogContainer from './layouts/default/DialogContainer.vue'
import SnackbarContainer from './layouts/default/SnackbarContainer.vue'
import UserProfileCompletionDialog from './components/UserProfileCompletionDialog.vue'

const authStore = useAuthStore()
const notificationStore = useNotificationStore()
const maintenanceStore = useMaintenanceStore()
const router = useRouter()
const { notifications } = notificationStore

// Route is the single renderer for MaintenanceView; navigate when the interceptor flips the flag
watch(() => maintenanceStore.active, (on) => {
  if (on && router.currentRoute.value.name !== 'Maintenance') {
    router.replace({ name: 'Maintenance' })
  }
})
</script>

<style>
/* Global styles for table links */
.v-table a {
  color: #1976d2;
  text-decoration: none;
  transition: color 0.2s;
}

.v-table a:hover {
  color: #1565c0;
  text-decoration: underline;
}

.auth-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: whitesmoke;
  z-index: 9999;
}
</style>
